import {NodeType} from "prosemirror-model";
import {Command, EditorState} from "prosemirror-state";
import {findWrapping, liftTarget} from "prosemirror-transform";
import {getParentWithNodeTypePos} from "./getParentWithNodeTypePos";

export const toggleWrap = (
    nodeType: NodeType,
    attrs?: Record<string, unknown>
): Command => (state, dispatch): boolean => {
    const { $from, $to } = state.selection

    const range = $from.blockRange($to)

    if (!range) {
        return false
    }

    const parentPos = getParentWithNodeTypePos(range.$from, nodeType)

    if (typeof parentPos === 'number') {
        // unwrap
        const target = liftTarget(range)

        if (typeof target !== 'number') {
            return false
        }

        if (dispatch) {
            dispatch(state.tr.lift(range, target).scrollIntoView())
        }

        return true
    } else {
        // wrap
        const wrapping = findWrapping(range, nodeType, attrs)

        if (!wrapping) {
            return false
        }

        if (dispatch) {
            dispatch(state.tr.wrap(range, wrapping).scrollIntoView())
        }

        return true
    }
}


export const canWrap = (
    nodeType: NodeType,
    attrs?: Record<string, unknown>
) => {
    const isWrappedInNodeTypeCheck = isWrapped(nodeType);
    return (state: EditorState): boolean => {
        if (isWrappedInNodeTypeCheck(state)) {
            return false // already wrapped
        }
        const { $from, $to } = state.selection
        const range = $from.blockRange($to)!;

        return findWrapping(range, nodeType, attrs) !== null;
    }
}

export const isWrapped = (nodeType: NodeType) => (
    state: EditorState
): boolean => {
    const { $from, $to } = state.selection

    const range = $from.blockRange($to)

    if (!range) {
        return false
    }

    return getParentWithNodeTypePos(range.$from, nodeType) !== undefined
}

